/**
 * Wrapper keys backends may nest a list under (raw array, wrapper object, JSON string,
 * or PHP-style numeric-key object) — checked in order by `coerceApiArray`.
 */
export const WRAPPER_KEYS = [
  'data',
  'Data',
  'notes',
  'Notes',
  'records',
  'Records',
  'items',
  'Items',
  'rows',
  'Rows',
  'result',
  'Result',
  'payload',
  'Payload',
  'audit_log',
  'auditLog',
  'AuditLog',
  'audit',
  'Audit',
  'logs',
  'Logs',
  'body',
  'Body',
  'value',
  'Value',
  'list',
  'List',
  'content',
  'Content',
  'response',
  'Response',
] as const
